import { createAction, props } from '@ngrx/store';

export interface FuzzySearchParams {
  query: string;
  person_titles?: string[];
  person_seniorities?: string[];
  person_locations?: string[];
  organization_locations?: string[];
}

// Define the possible payload types
type FuzzySearchPayload =
  | { query: string; }
  | { params: FuzzySearchParams; };

// Create a factory function for the action creator
function createFuzzySearchAction() {
  return createAction(
    '[Search] Fuzzy Search',
    (payload: FuzzySearchPayload) => {
      // Normalize the payload to always have 'params' format
      if ('query' in payload) {
        return { params: { query: payload.query } };
      }
      return payload;
    }
  );
}

export const allSearches = createAction(
  '[Search] All Searches',
  props<{ page: number, perPage: number, search: string, tags: any, archived: boolean, workspaceId?: string, sortBy?: string, sortDir?: 'asc' | 'desc', dateRange?: string }>()
);

/*
export const allSearchesSuccess = createAction(
  '[Search] All Searches Success',
  props<{ searches: [] }>()
);
*/

// Update the action to accept any type for searches
export const allSearchesSuccess = createAction(
  '[Search] All Searches Success',
  props<{ searches: any }>()
);

export const allSearchesFailure = createAction(
  '[Search] All Searches Failure',
  props<{ error: any; }>()
);

export const newSearch = createAction(
  '[Search] New Search',
  props<{ user_id: number, linkedin_profile: string, workspace_id?: string }>()
);

export const newSearchSuccess = createAction(
  '[Search] New Search Success',
  props<{ search: any }>()
);

export const newSearchFailure = createAction(
  '[Search] New Search Failure',
  props<{ error: any; }>()
);

export const fetchReport = createAction(
  '[Search] Fetch Report',
  props<{ reportId: number }>()
);

export const fetchReportSuccess = createAction(
  '[Search] Fetch Report Success',
  props<{ report: any }>()
);

export const fetchReportFailure = createAction(
  '[Search] Fetch Report Failure',
  props<{ error: any }>()
);

export const archiveReport = createAction(
  '[Search] Archive Report',
  props<{ reportId: number }>()
);

export const archiveReportSuccess = createAction(
  '[Search] Archive Report Success',
  props<{ archived_report: any }>()
);

export const archiveReportFailure = createAction(
  '[Search] Archive Report Failure',
  props<{ error: any }>()
);

export const restoreReport = createAction(
  '[Search] Restore Report',
  props<{ reportId: number }>()
);

export const restoreReportSuccess = createAction(
  '[Search] Restore Report Success',
  props<{ restored_report: any }>()
);

export const restoreReportFailure = createAction(
  '[Search] Restore Report Failure',
  props<{ error: any }>()
);

export const fetchSelfReport = createAction(
    '[Search] Fetch Self Report',
    props<{ public_profile_url }>()
);

export const fetchSelfReportSuccess = createAction(
    '[Search] Fetch Self Report Success',
    props<{ report: any }>()
);

export const fetchSelfReportFailure = createAction(
    '[Search] Fetch Self Report Failure',
    props<{ error: any }>()
);

export const clearReport = createAction(
  '[Report] Clear Report'
);
export const clearHubspot = createAction(
    '[Report] Clear Hubspot'
);
export const clearNotes = createAction(
  '[Report] Clear Notes'
);


export const updateReport = createAction(
  '[Search] Update Report',
  props<{ report: any }>()
);


// Notes
export const allNotes = createAction(
  '[Search] All Notes',
  props<{ search_id:number , user_id:number}>()
);

export const allNotesSuccess = createAction(
  '[Search] All Notes Success',
  props<{ notes: [] }>()
);

export const allNotesFailure = createAction(
  '[Search] All Notes Failure',
  props<{ error: any; }>()
);

export const assistantHistory = createAction(
  '[Search] Assistant History',
  props<{ search_id: number; search_company_id: number }>()
);

export const assistantHistorySuccess = createAction(
  '[Search] Assistant History Success',
  props<{ history: any }>()
);

export const assistantHistoryFailure = createAction(
  '[Search] Assistant History Failure',
  props<{ error: any }>()
);

export const askAssistant = createAction(
  '[Search] Ask Assistant',
  props<{ prompt: string; data: any; search_id: number; search_company_id: number }>()
);

export const askAssistantSuccess = createAction(
  '[Search] Ask Assistant Success',
  props<{ response: any }>()
);

export const askAssistantFailure = createAction(
  '[Search] Ask Assistant Failure',
  props<{ error: any }>()
);

export const clearAskAssistantResponse = createAction(
  '[Search] Clear Ask Assistant Response'
);

export const deleteNote = createAction(
  '[Search] Delete Notes',
  props<{ note_id:number, search_id:number}>()
);

export const deleteNoteSuccess = createAction(
  '[Search] Delete Note Success',
  props<{ deleted_note: [] }>()
);

export const deleteNoteFailure = createAction(
  '[Search] Delete Note Failure',
  props<{ error: any; }>()
);

export const createNote = createAction(
  '[Search] Create Notes',
  props<{ search_id:number, user_id:number, content:string }>()
);

export const createNoteSuccess = createAction(
  '[Search] Create Note Success',
  props<{ created_note: [] }>()
);

export const createNoteFailure = createAction(
  '[Search] Create Note Failure',
  props<{ error: any; }>()
);

export const getNotesSummary = createAction(
    '[Search] get Notes Summary ',
    props<{ search_id:number, user_id:number }>()
);

export const getNotesSummarySuccess = createAction(
    '[Search] get Notes Summary Success',
    props<{ notes_summary: [] }>()
);

export const getNotesSummaryFailure = createAction(
    '[Search] get Notes Summary Failure',
    props<{ error: any; }>()
);

export const showMoreNotes = createAction(
    '[Search] Show More Notes',
    props<{search_id:any ,page:number }>()
);

export const showMoreNotesSuccess = createAction(
    '[Search] Show More Notes  Success',
    props<{notes: [] }>()
);

export const showMoreNotesFailure = createAction(
    '[Search] Show More Notes Failure',
    props<{ error: any }>()
);

export const editNote = createAction(
  '[Search] Edit Notes',
  props<{ note:[], edited_note_text: string }>()
);

export const editNoteSuccess = createAction(
  '[Search]  Edit Note Success',
  props<{ edited_note: [] }>()
);

export const editNoteFailure = createAction(
  '[Search]  Edit Note Failure',
  props<{ error: any; }>()
);

export const markEventComplete = createAction(
  '[Report] Mark Event Complete',
  props<{ searchId: number; eventType: string }>()
);

export const updateIsLoading = createAction(
  '[Search] Update Is Loading',
  props<{ searchId: number; isLoading: boolean }>()
);

export const updateSearchState = createAction(
  '[Search] Update Search State',
  props<{ searchId: number; updates: Partial<any> }>() // Use Partial to allow partial updates
);

export const fuzzySearch = createFuzzySearchAction();

export const fuzzySearchSuccess = createAction(
  '[Search] Fuzzy Search Success',
  props<{ results: any[] }>()
);

export const fuzzySearchFailure = createAction(
  '[Search] Fuzzy Search Failure',
  props<{ error: any }>()
);

export const clearFuzzySearch = createAction(
  '[Search] Clear Fuzzy Search'
);

export const updateReportStatusInSearches = createAction(
  '[Search] Update Report Status In Searches',
  props<{ reportId: number, statusId: number }>()
);

// Profile Enrichment Actions

export const enrichProfile = createAction(
  '[Search] Enrich Profile',
  props<{ searchId: number }>()
);

export const enrichProfileSuccess = createAction(
  '[Search] Enrich Profile Success',
  props<{ data: any; message: string }>()
);

export const enrichProfileFailure = createAction(
  '[Search] Enrich Profile Failure',
  props<{ error: any }>()
);

export const updateReportEnrichStatus = createAction(
  '[Search] Update Report Enrich Status',
  props<{ isEnrich: number }>()
);

export const updateReportStatusInStore = createAction(
  '[Search] Update Report Status In Store',
  props<{ statusId: number }>()
);

// Generate Insights Actions
export const generateInsights = createAction(
  '[Search] Generate Insights',
  props<{ searchId: number; insightType: string }>()
);

export const generateInsightsSuccess = createAction(
  '[Search] Generate Insights Success',
  props<{ data: any; insightType: string; message?: string }>()
);

export const generateInsightsFailure = createAction(
  '[Search] Generate Insights Failure',
  props<{ error: any; insightType: string }>()
);

// Update Revenue Actions
export const updateRevenue = createAction(
  '[Search] Update Revenue',
  props<{ searchId: number; searchCompanyId: number; revenue: string; longDescription: string }>()
);

export const updateRevenueSuccess = createAction(
  '[Search] Update Revenue Success',
  props<{ data: any; message: string }>()
);

export const updateRevenueFailure = createAction(
  '[Search] Update Revenue Failure',
  props<{ error: any }>()
);

// Update Contact Info Actions
export const updateContactInfo = createAction(
  '[Search] Update Contact Info',
  props<{ searchId: number; contactType: string; emails: string[] | null; phones: string[] | null }>()
);

export const updateContactInfoSuccess = createAction(
  '[Search] Update Contact Info Success',
  props<{ data: any; message: string }>()
);

export const updateContactInfoFailure = createAction(
  '[Search] Update Contact Info Failure',
  props<{ error: any }>()
);
